import { Injectable } from '@angular/core';

interface Data {
  id: any;
  name: string;
}
interface Value {
  value: number;
  name: string;
}

export const tiers: Data[] = [
  { id: 1, name: 'Tier 1' },
  { id: 2, name: 'Tier 2' },
  { id: 3, name: 'Tier 3' }
];

export const typesNotes: Data[] = [
  { id: 1, name: 'Nota' },
  { id: 2, name: 'Entrevista' },
  { id: 3, name: 'Reseña' },
  { id: 4, name: 'Opinión' }
];

export const stages: Data[] = [
  { id: 1, name: 'Primicia' },
  { id: 2, name: 'Lanzamiento' },
  { id: 3, name: 'Mantenimiento' },
];

export const statusPlan: Data[] = [
  { id: 0, name: 'Planificado' },
  { id: 1, name: 'Aprobado' },
  { id: 2, name: 'Terminado' }
]

export const status: Data[] = [
  { id: 1, name: 'NO CONTACTADO' },
  { id: 2, name: 'SEGUIMIENTO' },
  { id: 3, name: 'APROBADO' },
  { id: 4, name: 'REALIZADO' },
  { id: 5, name: 'RESULTADO' }
]

export const statusPublic: Data[] = [
  { id: 1, name: 'PUBLICADO' },
  { id: 2, name: 'RECHAZADO' },
  { id: 3, name: 'CANCELADO' }
]

export const searchStatus: Data[] = [
  { id: 'st-1', name: 'NO CONTACTADO' },
  { id: 'st-2', name: 'SEGUIMIENTO' },
  // { id: 'st-3', name: 'APROBADO' },
  { id: 'st-4', name: 'REALIZADO' },
  { id: 'stp-1', name: 'PUBLICADO' },
  { id: 'stp-2', name: 'RECHAZADO' },
  { id: 'stp-3', name: 'CANCELADO' }
]

export const objectives: Value[] = [
  { name: 'Posicionamiento', value: 1 },
  { name: 'Ventas', value: 2 },
  { name: 'Branding', value: 3 },
  { name: 'Performance', value: 4 },
  { name: 'Promoción', value: 5 },
  { name: 'Lanzamiento', value: 6 }
]

export const audience: Value[] = [
  { name: 'APT', value: 1 },
  { name: '12+', value: 2 },
  { name: '14+', value: 3 },
  { name: '18+', value: 4 },
  { name: '30+', value: 5 },
  { name: '50+', value: 6 }
]

export const typePublic: Value[] = [
  { name: 'Empresas', value: 1 },
  { name: 'Personas', value: 2 }
]

@Injectable()
export class DetailConfi {
  constructor() { }

  getStatusMuestra(data) {
    if (data.muestrasRegistradas) {
      if (data.muestrasVerificadas) {
        return 'Verificado'
      } else {
        if (data.muestrasEnviadas) {
          return 'Enviado'
        } else {
          return 'Registrado'
        }
      }
    } else {
      return 'Sin Muestra'
    }
  }

  getStatus(el) {
    if (el.statusPublicado == 0) {
      const id = this.getIdStatus(el, 'estado')
      return status.find(stp => stp.id == id)
    } else {
      return statusPublic.find(stp => stp.id == el.statusPublicado)
    }

  }

  getIdStatus(el, state) {
    if (el.idDetallePlanMedioPadre) {
      if (el.detallePlanMedioPadre) {
        return el.detallePlanMedioPadre.bitacoras.length ? el.detallePlanMedioPadre.bitacoras[el.detallePlanMedioPadre.bitacoras.length - 1][state] : 1
      } else {
        return 5
      }

    } else {
      return el.bitacoras.length ? el.bitacoras[el.bitacoras.length - 1][state] : 1
    }

  }
}
